import axios from "axios";
import React, { createContext, useEffect, useState } from "react";
import { ENDPOINT, getJWT } from "../helpers/Helper";

export const FavouriteContext = createContext();

function FavouriteContextProvider(props) {
  const [favouritesData, setFavouritesData] = useState();
  const [triggerFavourites, setTriggerFavourites] = useState(false);

  useEffect(() => {
    const jwt = getJWT();

    axios
      .get(`${ENDPOINT}/products/bookmarks`, {
        headers: { Authorization: `Bearer ${jwt}` },
      })
      .then((res) => {
        setFavouritesData(res && res.data.data);
      })
      .catch((err) => {
        console.log(err.response.data.error);
      });
  }, [triggerFavourites]);

  const triggerFavouritesReload = () => {
    setTriggerFavourites(!triggerFavourites);
  };
  return (
    <FavouriteContext.Provider
      value={{ favouritesData, triggerFavouritesReload }}
    >
      {props.children}
    </FavouriteContext.Provider>
  );
}

export default FavouriteContextProvider;
